import { HOME_AI_MODEL_SELECT_OPTIONS } from "./homeAiModelSelectOptions";

export function useAiAskBarSelectedModel({ catalog, value, selectedModel }) {
  const selectedId = value ?? selectedModel;
  const selectedOption =
    [...catalog.tiers, ...catalog.models].find(
      (item) => item.value === selectedId,
    ) ?? HOME_AI_MODEL_SELECT_OPTIONS[0];
  return { selectedId, selectedOption };
}
